export const SHOW_ERROR = "SHOW_ERROR"
export const SHOW_WARNING = "SHOW_WARNING"
export const SHOW_INFORMATION = "SHOW_INFORMATION"
export const SHOW_SUCCESS = "SHOW_SUCCESS"
export const CLOSE_ALERT = "CLOSE_ALERT"
